import {Routes, Route, Navigate} from 'react-router-dom'

import Home from '../pages/Home';
import About from '../pages/About';
import Contact from '../pages/Contact';
import Space from '../pages/Space';
import Events from '../pages/Events';
import Member from '../pages/Member';
import Career from '../pages/Career';
import Faq from '../pages/Faq';
import Bloq from '../pages/Blog';
import Service from '../pages/Services';
import Location from '../pages/Location';
import Price from '../pages/Price';
import Virtual from '../pages/Virtual';
import PrivateOffices from '../pages/PrivateOffices';
import ExectiveOffices from '../pages/ExectiveOffices';
import Cont from '../pages/Cont';
import Privacy from '../pages/Privacy';
import Newpage from '../pages/Newpage';
const Routers =()=> {
  return (
    <Routes>
      <Route path='/' element={<Home/>} />
      <Route path='/home' element={<Home/>} />
      <Route path='/about' element={<About/>} />
      <Route path='/contact' element={<Contact/>} />
      <Route path='/space' element={<Space/>} />
      <Route path='/event' element={<Events/>} />
      <Route path='' element={<Member/>} />
      <Route path='/career' element={<Career/>} />
      <Route path='/faq' element={<Faq/>} />
      <Route path='/blog' element={<Bloq/>} />
      <Route path='/service' element={<Service/>} />
      <Route path='/uptown-post-oak' element={<Location/>} />
            <Route path='/pricing' element={<Price/>} />PrivateOffices
                        <Route path='/virtual-office' element={<Virtual/>} />
                        
                        <Route path='/private-offices' element={<PrivateOffices/>} />
                        <Route path='/executive-suites' element={<ExectiveOffices/>} />
                        <Route path='/xceed-networking-event' element={<Cont/>} />
                        <Route path='/Privacy-Policy' element={<Privacy/>} />
                         <Route path='/realtor-partner' element={<Newpage/>} />
</Routes>
  )
};
export default Routers;
























